// @ts-expect-error: implicitly has an 'any' type
import buildFormatLongFn from 'date-fns/locale/_lib/buildFormatLongFn';
import enUsLocale from 'date-fns/locale/en-US';

const dateTimeFormats = {
  full: "{{date}} 'sa' {{time}}",
  long: "{{date}} 'sa' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}',
};

export const formatLong: Locale['formatLong'] = {
  date: enUsLocale.formatLong!.date,
  time: enUsLocale.formatLong!.time,
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full',
  }),
};
